module.exports = __webpack_public_path__ + "dba082d3eedbed8b99f32c841b35d951.svg";